<!-- @format -->

<sis-expandable [closed]="false" [title]="title">
  <ng-template sisExpandableHeaderButtons>
    <sis-button hollow="true" [ariaLabel]="('ARIA_LABEL.DELETE' | translate) + ' ' + title" (clicked)="delete.emit()">
      <sis-icon icon="delete"></sis-icon>
    </sis-button>
  </ng-template>
  <ng-template sisExpandableContent>
    <div class="row">
      <div class="col-12">
        <sis-required-field-legend class="float-end"></sis-required-field-legend>
      </div>
    </div>
    @if (name) {
      <div class="row">
        <div class="col-9">
          <div class="form-group">
            <sis-text-field
              [control]="name"
              [label]="'STUDENT_APPLICATIONS.PRIOR_LEARNING.COMPETENCE_NAME' | translate"
              id="prior-learning-name"
              name="name">
            </sis-text-field>
          </div>
        </div>
      </div>
    }
    @if (organisation) {
      <div class="row">
        <div class="col-9">
          <div class="form-group">
            <sis-text-field
              [control]="organisation"
              [label]="'STUDENT_APPLICATIONS.PRIOR_LEARNING.COMPETENCE_ORGANISATION' | translate"
              helpBlock="STUDENT_APPLICATIONS.PRIOR_LEARNING.COMPETENCE_ORGANISATION_INFO"
              id="prior-learning-organisation"
              name="organisation">
            </sis-text-field>
          </div>
        </div>
      </div>
    }
    <div class="row">
      @if (attainmentPeriod) {
        <div class="col-9 col-sm-6 col-xl-4">
          <div class="form-group">
            <label [class]="getLabelState(attainmentPeriod) || 'required'" for="prior-learning-attainment-period">
              {{ "STUDENT_APPLICATIONS.PRIOR_LEARNING.COMPETENCE_ATTAINMENT_PERIOD" | translate }}
            </label>
            <sis-local-date-range-editor
              [control]="attainmentPeriod"
              [hideLabels]="true"
              id="prior-learning-attainment-period"
              name="attainmentPeriod">
            </sis-local-date-range-editor>
          </div>
        </div>
      }
      @if (attainmentLanguage) {
        <div class="col-9 col-xl-4 offset-xl-1">
          <div class="form-group">
            <label [for]="'language-code-select'" [class]="getLabelState(attainmentLanguage)">{{
              "STUDENT_APPLICATIONS.ATTAINMENT_LANGUAGE" | translate
            }}</label>
            <sis-code-select-editor
              [id]="'language-code-select'"
              [codebookUrn]="languageCodeBookUrn"
              [selectedUrn]="attainmentLanguage.value"
              [required]="true"
              [attr.data-cy]="'prior-competence-attainment-language-editor'"
              (onSelectCode)="onAttainmentLanguageChange($event.selectedUrn)">
            </sis-code-select-editor>
            <sis-validation-errors [control]="attainmentLanguage" [formFieldId]="'language-code-select'" [ariaLive]="false" />
          </div>
        </div>
      }
    </div>
    @if (description) {
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <sis-text-field
              [control]="description"
              [label]="'STUDENT_APPLICATIONS.PRIOR_LEARNING.COMPETENCE_DESCRIPTION' | translate"
              [textarea]="true"
              id="prior-learning-description"
              name="description">
            </sis-text-field>
          </div>
        </div>
      </div>
    }
  </ng-template>
</sis-expandable>
